import { ObjectSchema } from 'yup';

import { TypeBase } from './TypeBase';

export abstract class ObjectTypeBase extends TypeBase<ObjectSchema<any>> {}
